export default "__VITE_ASSET__7mc0qg4g__"